import React from 'react';

const ReportComponent = React.lazy(() => import('pages/ReportComponent/ReportComponent'));

const ReportComponentRoutes = [
  {
    path: '/report-component',
    exact: true,
    name: 'Báo cáo linh kiện sử dụng nhiều nhất',
    function: 'REPORT_COMPONENT',
    component: ReportComponent,
  },
];

export default ReportComponentRoutes;
